import React from 'react';
import {useSelector} from 'react-redux';
import ActionStripe from '../../comp/stripe/actionStripe';
import AppSectionContainer from "./container/appSectionContainer";
import {APP_SECTION_HEADER, APP_SECTION_SUBHEADER, MIT_GBIZ} from "../../core/const";
import {FocusPage, StripeHeader, StripeTitle} from "@george-labs.com/design-system";
import Resource from "../../core/serverResource";

const ApplicationHeader = () => {
    const subject = useSelector(state => state.messenger?.mergedSubject || "");
    const humanTaskLabel = useSelector(state => state.humanTask?.humanTask?.label || "");

    const mitModule = Resource.getMitModule()

    const getStripeHeader = () => {
        return (
            <StripeHeader color={mitModule === MIT_GBIZ ? StripeHeader.COLOR.BLUE_400 : StripeHeader.COLOR.BLUE_300}
                          center={<StripeTitle>{mitModule === MIT_GBIZ ? humanTaskLabel : "Zprávy s bankéřem"}</StripeTitle>}/>
        )
    };

    return <>
        <AppSectionContainer className={mitModule === MIT_GBIZ ? 'g-bg-blue-400' : 'g-bg-blue-300'} name={APP_SECTION_HEADER} full={true}>
            <FocusPage stripeHeader={getStripeHeader()}/>
        </AppSectionContainer>

        {subject ?
            <AppSectionContainer className='g-bg-white border-bottom' name={APP_SECTION_SUBHEADER}>
                <ActionStripe/>
            </AppSectionContainer>
            : null}
    </>;
};

export default ApplicationHeader;